import { NgModule } from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { rlPdfViewerComponent } from './pdf-viewer/rl-pdf-viewer.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpLoaderFactory } from '../services/httpLoaderFactory';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { RlCommonModule } from '../rl-common/rl-common.module';
import { EmbeddedViewComponent } from './embedded-view.component';
import { AnnotationsModule } from '../annotations/annotations.module';
import { ViewerComponent } from './viewer/viewer.component';
import { AnnotationsPillsComponent } from './annotations-pills/annotations-pills.component';
import { TabsModule } from 'ngx-bootstrap/tabs';

@NgModule({
    imports: [
        PdfViewerModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        RlCommonModule,
        AnnotationsModule,
        TabsModule.forRoot()
    ],
    declarations: [
        rlPdfViewerComponent,
        EmbeddedViewComponent,
        ToolbarComponent,
        ViewerComponent,
        AnnotationsPillsComponent
    ],
    providers: [],
    exports: [
        EmbeddedViewComponent,
        ViewerComponent
    ]
})
export class EmbeddedViewModule { }
